import { useEffect, useState, useRef } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Save, Palette } from "lucide-react";

const SETTING_DEFAULTS = {
  "--idg-bg": "#0a0a0c",
  "--idg-panel": "#131315",
  "--idg-panel-2": "#1a1a1d",
  "--idg-border": "#222226",
  "--idg-border-soft": "#1e1e22",
  "--idg-text": "#f4f4f5",
  "--idg-muted": "#a1a1aa",
  "--idg-cyan": "#00e5ff",
  "--idg-orange": "#ff4f00",
  "--idg-purple": "#8b5cf6",
  "--idg-red": "#ef4444",
  "--idg-green": "#10b981",
  "--idg-radius": "0.375rem",
  "--idg-shadow": "0 4px 6px -1px rgba(0, 0, 0, 0.5)",
};

export default function IDGThemeSettingsTab() {
  const [settings, setSettings] = useState(SETTING_DEFAULTS);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/api/idg-theme-settings");
      if (data.settings && data.settings.length > 0) {
        const merged = { ...SETTING_DEFAULTS };
        data.settings.forEach(s => {
          merged[s.key] = s.value;
        });
        setSettings(merged);
      }
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleChange = (k, v) => {
    setSettings(prev => ({ ...prev, [k]: v }));
    // Live preview via IDG Core
    if (window.IDG && window.IDG.theme) {
      window.IDG.theme.set(k, v);
    }
  };

  const save = async () => {
    setLoading(true);
    try {
      await api.post("/admin/api/idg-theme-settings/save", settings);
      toast.success("Setări salvate și aplicate global!");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="tf-section-title flex items-center gap-2">
          <Palette className="w-5 h-5 text-[var(--idg-cyan)]" /> IDG Theme Settings
        </h2>
        <button onClick={save} disabled={loading} className="idg-btn idg-btn-cyan">
          <Save className="w-4 h-4" /> {loading ? "Se salvează..." : "Salvează"}
        </button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(settings).map(([key, value]) => (
          <div key={key} className="idg-card">
            <div className="idg-card-body flex items-center justify-between gap-4 p-4">
              <div className="text-sm font-semibold">{key}</div>
              <div className="flex items-center gap-2">
                {key.startsWith("--idg-") && (key.includes("color") || !key.includes("radius") && !key.includes("shadow")) ? (
                  <input
                    type="color"
                    value={value}
                    onChange={(e) => handleChange(key, e.target.value)}
                    className="w-8 h-8 rounded cursor-pointer border-0 p-0"
                  />
                ) : (
                  <input
                    type="text"
                    value={value}
                    onChange={(e) => handleChange(key, e.target.value)}
                    className="idg-input text-xs w-32"
                  />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
